'use client'

import NextTopLoader from 'nextjs-toploader'

export default function NavigationProgress() {
  return (
    <NextTopLoader
      color="#FF6100"
      height={3}
      showSpinner={false}
      showForHashAnchor={false}
      shadow={false}
      crawlSpeed={250}
      speed={200}
      zIndex={9999}
      template='<div class="bar" role="bar" aria-hidden="true"><div class="peg"></div></div>'
    />
  )
}
